import type { ExplorationVolume } from '../../types/exploration';
import { buildInfrastructureOptions } from '../../lib/filters/buildCheckboxFilterOptions';
import FilterCheckboxList from './FilterCheckboxList';

export default function InfrastructureFilter({
  volumes,
  pendingInfrastructureFilters,
  setPendingInfrastructureFilters,
  isDisclosureOpen = false,
}: {
  volumes: ExplorationVolume[];
  pendingInfrastructureFilters: string[];
  setPendingInfrastructureFilters: (filters: string[]) => void;
  isDisclosureOpen?: boolean;
}) {
  const options = buildInfrastructureOptions(volumes);

  const handleChange = (key: string) => {
    if (pendingInfrastructureFilters.includes(key)) {
      setPendingInfrastructureFilters(pendingInfrastructureFilters.filter((k) => k !== key));
    } else {
      setPendingInfrastructureFilters([...pendingInfrastructureFilters, key]);
    }
  };

  if (!options.length) return null;

  return (
    <FilterCheckboxList
      options={options}
      isDisclosureOpen={isDisclosureOpen}
      isSelected={(key) => pendingInfrastructureFilters.includes(key)}
      onToggle={handleChange}
    />
  );
}

export function buildInfrastructureFilterOptions(volumes: ExplorationVolume[]) {
  return buildInfrastructureOptions(volumes);
}
